var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0236 16.0109C30.0236 24.1574 23.4149 30.7621 15.2618 30.7621C7.10877 30.7621 0.5 24.1574 0.5 16.0109C0.5 7.86432 7.10877 1.25964 15.2618 1.25964C23.4149 1.25964 30.0236 7.86432 30.0236 16.0109Z",
    stroke: "#F6F5F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7780_1166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6528 16.9419L19.0665 14.246H16.4797V12.4965C16.4797 11.759 16.8411 11.04 17.9996 11.04H19.1756V8.74476C19.1756 8.74476 18.1085 8.56262 17.0881 8.56262C14.9578 8.56262 13.5653 9.85385 13.5653 12.1913V14.246H11.1973V16.9419H13.5653V23.4592H16.4797V16.9419H18.6528Z",
    fill: "#F6F5F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7780_1166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.8966,
    height: 14.8966,
    fill: "white",
    transform: "translate(7.73828 8.56262)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ef7823e033c6851eead84965007cf12d.svg";
export { ForwardRef as ReactComponent };